import AlbumCover from '../KrakatoaMay23/AlbumCover.jpg'
import IMG1 from '../KrakatoaMay23/CampingintheSkiesKrakMay230065.jpg'
import IMG2 from '../KrakatoaMay23/CampingintheSkiesKrakMay230068.jpg'
import IMG3 from '../KrakatoaMay23/CampingintheSkiesKrakMay230071.jpg'
import IMG4 from '../KrakatoaMay23/CampingintheSkiesKrakMay230079.jpg'
import IMG5 from '../KrakatoaMay23/CampingintheSkiesKrakMay230082.jpg'
import IMG6 from '../KrakatoaMay23/CampingintheSkiesKrakMay230085.jpg'
import IMG7 from '../KrakatoaMay23/CampingintheSkiesKrakMay230093.jpg'
import IMG8 from '../KrakatoaMay23/CampingintheSkiesKrakMay230099.jpg'
import IMG9 from '../KrakatoaMay23/CampingintheSkiesKrakMay230102.jpg'
import IMG10 from '../KrakatoaMay23/CampingintheSkiesKrakMay230107.jpg'
import IMG11 from '../KrakatoaMay23/CampingintheSkiesKrakMay230108.jpg'
import IMG12 from '../KrakatoaMay23/CampingintheSkiesKrakMay230110.jpg'
import IMG13 from '../KrakatoaMay23/CampingintheSkiesKrakMay230114.jpg'
import IMG14 from '../KrakatoaMay23/CampingintheSkiesKrakMay230124.jpg'
import IMG15 from '../KrakatoaMay23/CampingintheSkiesKrakMay230126.jpg'
import IMG16 from '../KrakatoaMay23/CampingintheSkiesKrakMay230129.jpg'
import IMG17 from '../KrakatoaMay23/CampingintheSkiesKrakMay230138.jpg'
import IMG18 from '../KrakatoaMay23/CampingintheSkiesKrakMay230144.jpg'
import IMG19 from '../KrakatoaMay23/CampingintheSkiesKrakMay230148.jpg'
import IMG20 from '../KrakatoaMay23/CampingintheSkiesKrakMay230154.jpg'
import IMG21 from '../KrakatoaMay23/CampingintheSkiesKrakMay230167.jpg'
import IMG22 from '../KrakatoaMay23/CampingintheSkiesKrakMay230182.jpg'
import IMG23 from '../KrakatoaMay23/CampingintheSkiesKrakMay230187.jpg'
import IMG24 from '../KrakatoaMay23/CampingintheSkiesKrakMay230199.jpg'
import IMG25 from '../KrakatoaMay23/CampingintheSkiesKrakMay230200.jpg'
import IMG26 from '../KrakatoaMay23/CampingintheSkiesKrakMay230227.jpg'
import IMG27 from '../KrakatoaMay23/CampingintheSkiesKrakMay230231.jpg'
import IMG28 from '../KrakatoaMay23/CampingintheSkiesKrakMay230233.jpg'
import IMG29 from '../KrakatoaMay23/CampingintheSkiesKrakMay230234.jpg'
import IMG30 from '../KrakatoaMay23/CampingintheSkiesKrakMay230239.jpg'
import IMG31 from '../KrakatoaMay23/CampingintheSkiesKrakMay230243.jpg'
import IMG32 from '../KrakatoaMay23/CampingintheSkiesKrakMay230249.jpg'
import IMG33 from '../KrakatoaMay23/CampingintheSkiesKrakMay230255.jpg'
import IMG34 from '../KrakatoaMay23/CampingintheSkiesKrakMay230258.jpg'
import IMG35 from '../KrakatoaMay23/CampingintheSkiesKrakMay230259.jpg'
import IMG36 from '../KrakatoaMay23/CampingintheSkiesKrakMay230260.jpg'
import IMG37 from '../KrakatoaMay23/CampingintheSkiesKrakMay230261.jpg'
import IMG38 from '../KrakatoaMay23/CampingintheSkiesKrakMay230262.jpg'
import IMG39 from '../KrakatoaMay23/CampingintheSkiesKrakMay230266.jpg'
import IMG40 from '../KrakatoaMay23/CampingintheSkiesKrakMay230276.jpg'
import IMG41 from '../KrakatoaMay23/CampingintheSkiesKrakMay230287.jpg'
import IMG42 from '../KrakatoaMay23/CampingintheSkiesKrakMay230289.jpg'
import IMG43 from '../KrakatoaMay23/CampingintheSkiesKrakMay230314.jpg'
import IMG44 from '../KrakatoaMay23/CampingintheSkiesKrakMay230324.jpg'

export const KrakatoaMay23List = [
  AlbumCover,
  IMG1,
  IMG2,
  IMG3,
  IMG4,
  IMG5,
  IMG6,
  IMG7,
  IMG8,
  IMG9,
  IMG10,
  IMG11,
  IMG12,
  IMG13,
  IMG14,
  IMG15,
  IMG16,
  IMG17,
  IMG18,
  IMG19,
  IMG20,
  IMG21,
  IMG22,
  IMG23,
  IMG24,
  IMG25,
  IMG26,
  IMG27,
  IMG28,
  IMG29,
  IMG30,
  IMG31,
  IMG32,
  IMG33,
  IMG34,
  IMG35,
  IMG36,
  IMG37,
  IMG38,
  IMG39,
  IMG40,
  IMG41,
  IMG42,
  IMG43,
  IMG44,
];
